import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../../../features/auth";
import { PATHS } from "../../../routes/paths";
import { highestRole } from "@myapp/contract";

interface Props {
  children: React.ReactNode;
}

export const PublicOnly = ({ children }: Props) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) return <>{children}</>;

  const highest = user?.roles?.length ? highestRole(user.roles) : null;

  switch (highest) {
    case 'MANAGER':
      return <Navigate to={PATHS.workOrderPage} replace />;
    case 'WORKER':
      return <Navigate to={PATHS.workerCalendar} replace />;
    case 'SUPERUSER':
    case 'DIRECTOR':
      return <Navigate to={PATHS.users} replace />;
    default:
      return <Navigate to={PATHS.workOrderPage} replace />;
  }
};
